import { ConfigProvider, Form } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'translations/hooks';

import { OnChangeGraphFilters } from 'business/data-analysis/pages/graph/components/filter-card/hooks/types';
import { useGenerateGraphs } from 'business/data-analysis/pages/graph/hooks/use-generate-graphs';
import { GraphFilters } from 'business/data-analysis/pages/graph/types';
import { PreselectTemporalSelectInput } from 'ui/form/preselect-date-select-input';

export const DataAnalysisMobileFilters = ({
  filters,
  onChangeFilters,
}: {
  filters: GraphFilters;
  onChangeFilters: OnChangeGraphFilters;
}) => {
  const { t } = useTranslation();

  const { generateGraphs } = useGenerateGraphs(filters);

  const staticHookDependancyArray = [
    filters.dateFilters.startDate.format(),
    filters.dateFilters.endDate.format(),
  ] as const;

  useEffect(() => {
    generateGraphs();
    // Only refetch when filters update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, staticHookDependancyArray);

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Form.Item layout="vertical" label={t('dataAnalysis.labels.dateFilter')}>
        <PreselectTemporalSelectInput
          mode="hour"
          value={[filters.dateFilters.startDate, filters.dateFilters.endDate]}
          onChange={onChangeFilters.onChangeDateRange}
          defaultDate={dayjs()}
        />
      </Form.Item>
    </ConfigProvider>
  );
};
